/*
 * @Description:
 * @Date: 2019-03-29 13:49:26
 */
import dateFormat from '@/tools/dateFormat';

export default {
  data() {
    return {
      dateValue: ''
    };
  },
  methods: {
    dateChange(e) {
      // 时间格式化
      this.searchQuery.taskDt = this.searchQuery.taskDate = this.searchQuery.dateRange =
        e || '';
    }
  },
  created() {
    if (!this.noNeedForDate) {
      let end = new Date();
      let start = Date.now();
      if (!this.noNeedInitDate) {
        this.searchQuery.taskDt = this.searchQuery.taskDate = this.searchQuery.dateRange = this.dateValue = dateFormat(
          start,
          'YYYY-MM'
        );
      }
    }
  }
};
